import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Componente de botón de actualización para tableros Kanban
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isRefreshDisabled - Si el botón de actualización está deshabilitado
 * @param {number} props.countdown - Contador de tiempo para la próxima actualización
 * @param {Function} props.onRefresh - Función para manejar la actualización
 * @returns {React.ReactElement} - Elemento de botón de actualización
 */
const KanbanRefreshButton = ({ isRefreshDisabled, countdown, onRefresh }) => {
  const DEFAULT_COLOR = '#7d56b2';
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <Tooltip title={isRefreshDisabled ? `Espere ${countdown} segundos para actualizar de nuevo` : 'Actualizar datos del tablero'}>
        <span>
          <Button
            variant="contained"
            onClick={onRefresh}
            disabled={isRefreshDisabled}
            startIcon={<RefreshIcon />}
            sx={{
              backgroundColor: DEFAULT_COLOR,
              '&:hover': {
                backgroundColor: '#6a4a9a',
              },
              fontSize: { xs: '0.8rem', sm: '0.875rem', md: '1rem' },
              padding: { xs: '6px 12px', sm: '8px 16px', md: '10px 20px' },
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 'bold',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              transition: 'all 0.3s ease-in-out',
              whiteSpace: 'nowrap',
              minWidth: { xs: '100%', sm: 'auto' }
            }}
          >
            {isRefreshDisabled ? `Actualizando... (${countdown}s)` : 'Actualizar Datos'}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default KanbanRefreshButton;
